import BasePageMixin from 'vue-template/common/mixins/BasePageMixin';
import { asBoolean } from 'core/utils';

export default {
  mixins: [BasePageMixin],

  data() {
    return {
      instance: null,
      isNew: null,
    };
  },

  computed: {
    editing() {
      return this.isNew || asBoolean(this.$route.query.edit);
    }
  },

  watch: {
    $route() {
      this.load();
    }
  },

  async mounted() {
    await this.load();
  },

  methods: {
    getService() {
      throw Error('getService() method not implemented');
    },

    async load() {
      try {
        this.isNew = this.$route.params.id === "new";
        const { data } = this.isNew
          ? await this.getService().create()
          : await this.getService().load({ id: this.$route.params.id });
        this.instance = data;
        //console.log('Loaded', data);
        this.$emit("breadcrumbs", this.breadcrumbs());
      } catch (e) {
        await this.handleError(e);
      }
    }
  }
};
